<template>
  <div>
    <div
      class="dbc-gc-form c-registration-step__action-code"
      v-if="!isTariffSelected && !isActionCodeSubmitted"
    >
      <div class="dbc-gc-form__field c-form-field__action-code">
        <label class="dbc-gc-form__label sentry-unmask" for="c-action-code">{{
          $t('dbc-text-action-code-question')
        }}</label>
        <input
          class="dbc-gc-form__input sentry-unmask"
          id="c-action-code"
          type="text"
          :placeholder="$t('dbc-label-action-code')"
          :value="actionCode"
          @input="
            actionCode = ($event.target as HTMLInputElement).value.replace(
              /\s/g,
              ''
            )
          "
        />
      </div>
      <button
        :disabled="actionCode === '' || isActionCodeLoading"
        class="dbc-gc-btn dbc-gc-form__button c-registration-button"
        :class="{
          'c-registration-button--loading': isActionCodeLoading,
        }"
        @click="submitActionCode"
      >
        {{ $t('dbc-button-redeem') }}
      </button>
      <div class="c-registration__error sentry-unmask" v-if="actionCodeError">
        {{ actionCodeError }}
      </div>
    </div>
    <div class="c-action-code__status" v-if="isActionCodeSubmitted">
      {{ $t('dbc-text-action-code-redeemed') }}
    </div>
    <div
      class="c-action-code__status"
      v-if="isTariffSelected && actionCode === ''"
    >
      {{ $t('dbc-text-action-code-not-redeemed') }}
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  isActionCodeLoading: boolean
  actionCodeError: string
}>()

const emit = defineEmits<{
  (e: 'submitActionCode', actionCode: string): void
}>()

const actionCode = ref('')

const isTariffSelected = inject('isTariffSelected')
const isActionCodeSubmitted = inject('isActionCodeSubmitted')

function submitActionCode() {
  emit('submitActionCode', actionCode.value)
}
</script>
